import { createContext } from "react"

export const GpraContext = createContext(null)
